export default newFilters => {
  const urlStrings = {
    carDelivery: 'Car%20Delivery',
    trocaComTroco: 'Troca%20Com%20Troco',
    superPreco: 'Super%20Preco',
    videoChamada: 'Videochamada',
    'visão360°': 'Vis%C3%A3o360%C2%B0',
    vistoriado: 'Vistoriado'
  }
  const urlStringsKeys = Object.keys(urlStrings)
  const appliedFilters = Object.keys(newFilters).filter(
    key => newFilters[key] && key !== 'superSealOff'
  )
  const appliedFiltersStrings = []

  let finalUrl = ''

  if (appliedFilters.length > 0) {
    for (let i = 0; i < appliedFilters.length; i++) {
      for (let j = 0; j < urlStringsKeys.length; j++) {
        if (appliedFilters[i] === urlStringsKeys[j]) {
          appliedFiltersStrings.push(urlStrings[appliedFilters[i]])
          break
        }
      }
    }

    finalUrl = appliedFiltersStrings.map((filter, index) => {
      if (index === appliedFilters.length - 1) return filter
      return `${filter}|`
    })
    finalUrl = `&Oportunidades=${finalUrl.join('')}`
  }

  return finalUrl
}
